import 'bootstrap/dist/css/bootstrap.min.css';
import 'leaflet/dist/leaflet.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";

// Load before first render to prevent Flash Of Unstyled Text (FOUT) when dropdowns first open
document.fonts.load("300 1em 'Open Sans'").catch(() => {
  // Ignore font loading errors, as the app can still function without the font
});

// Polyfills to allow code to run on older browsers
import 'core-js';
import 'whatwg-fetch';
import 'yet-another-abortcontroller-polyfill';
import './i18n';

import * as React from 'react';
import { App } from './containers/app/app';
import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('mount'))
  .render(<App />);
